/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do values above or below 1 mean?`)
};

const es_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significan los valores por encima o por debajo de 1?`)
};

const de_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeuten Werte über oder unter 1?`)
};

const nl_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekenen waarden boven of onder 1?`)
};

const fr_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifient les valeurs supérieures ou inférieures à 1 ?`)
};

const it_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significano valori sopra o sotto 1?`)
};

const pt_br2_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significam valores acima ou abaixo de 1?`)
};

const pt_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significam valores acima ou abaixo de 1?`)
};

const ja_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1を超える値や1未満の値は何を意味しますか？`)
};

const zh_rscu_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高于或低于 1 的值代表什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_faq_q3", locale)
	if (locale === "en") return en_rscu_faq_q3(inputs)
	if (locale === "es") return es_rscu_faq_q3(inputs)
	if (locale === "de") return de_rscu_faq_q3(inputs)
	if (locale === "nl") return nl_rscu_faq_q3(inputs)
	if (locale === "fr") return fr_rscu_faq_q3(inputs)
	if (locale === "it") return it_rscu_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_faq_q3(inputs)
	if (locale === "pt") return pt_rscu_faq_q3(inputs)
	if (locale === "ja") return ja_rscu_faq_q3(inputs)
	return zh_rscu_faq_q3(inputs)
};